import { gql } from '@apollo/client';

import { AssignmentAnswer } from '../../types';
import { assignmentAnswerFragment } from '../fragments';

export interface GetAssignmentAnswersQueryVariables {
  courseId: string;
  assignmentId: string;
}

export interface GetAssignmentAnswersQueryResult {
  answers: AssignmentAnswer[];
}

export const getAssignmentAnswersQuery = gql`
  query GetAssignmentAnswersQuery($courseId: String!, $assignmentId: String!) {
    answers(courseId: $courseId, assignmentId: $assignmentId)
      @rest(type: "AssignmentAnswer", path: "courses/{args.courseId}/assignments/{args.assignmentId}/answers") {
      ...AssignmentAnswer
    }
  }
  ${assignmentAnswerFragment}
`;
